import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { postUserEnrollMFA } from '@arrived/api_v2';
import { ApiError, MfaDetails, UserId } from '@arrived/models';

import { userMFADetailsKeyFn } from './users.mfa.keys';

export function usePostCreateMFAEnrollmentMutation(options?: UseMutationOptions<MfaDetails, ApiError, UserId>) {
  const queryClient = useQueryClient();
  return useMutation((userId) => postUserEnrollMFA(userId), {
    ...options,
    onSuccess: (...result) => {
      queryClient.invalidateQueries(userMFADetailsKeyFn(result[1]));
      options?.onSuccess && options.onSuccess(...result);
    },
  });
}
